import L from "leaflet";

const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = ""
) => {
  //---------------allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    let isInCluster = false;
    const clusterChildMarkers = cluster.getAllChildMarkers();
    if (selectedInstitution) {
      for (const clusterChildMarker of clusterChildMarkers) {
        if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
          isInCluster = true;
          //cluster.spiderfy();
        }
      }
    }

    return L.divIcon({
      // Cluster icon
      // html: `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
      //         <circle id="Ellipse_3" data-name="Ellipse 3" cx="22" cy="22" r="22"/>
      //       </svg>
      //       <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
      //       `,
      html: `
     <div class="leaflet-marker-icon custom-marker-cluster leaflet-zoom-animated leaflet-interactive">
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
            <circle id="Ellipse_3" data-name="Ellipse 3" cx="22" cy="22" r="16"/>
        </svg>
        <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
    </div>
`,
      iconSize: L.point(35, 35, true),
      iconAnchor: [17, 17],
      className: "custom-marker-cluster",
    });
  } else {
    const fillColor = color.length !== 0 ? color[0] : "#999999"
    // One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin`,
      iconSize: [30, 30], // size of the icon
      iconAnchor: [15, 30],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -36],
      html: `<div class="markerIcon leaflet-marker-icon">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="40px" height="40px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
        <g>
          <path fill="${fillColor}" class="st5" d="M425.3,89.7C386.4,33.3,324.6,1,256,1C187.4,1,125.7,33.3,86.7,89.7c-38.7,56.1-47.7,127-24,189.8
            c6.3,17.1,16.4,33.8,29.9,49.4l149.8,175.9c3.4,4,8.4,6.3,13.6,6.3c5.2,0,10.2-2.3,13.6-6.3l149.7-175.9
            c13.5-15.7,23.6-32.3,29.9-49.3C473,216.7,464,145.7,425.3,89.7z M256,306.5c-55.1,0-99.9-44.8-99.9-99.9s44.8-99.9,99.9-99.9
            s99.9,44.8,99.9,99.9C355.9,261.7,311.1,306.5,256,306.5z"/>
        </g>
        </svg>
          <div class="pulse">
          </div>
        </div>
    `,
    });
    return icon1;
  }
};

export default MarkerIcon;

